import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { spacing } from '@naf/theme';

export const AnimatedText = styled(Text)`
  margin-bottom: ${spacing.space24};
  text-align: center;
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
`;

export const LoaderWrapper = styled.div`
  margin-top: ${spacing.space24};
`;
